import { render, staticRenderFns } from "./RecipesScraper.vue?vue&type=template&id=a13ff2c0"
import script from "./RecipesScraper.vue?vue&type=script&lang=js"
export * from "./RecipesScraper.vue?vue&type=script&lang=js"
import style0 from "./RecipesScraper.vue?vue&type=style&index=0&id=a13ff2c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports